import request from '@/utils/request'


// 单位列表
export function getUnit(query) {
  return request({
    url: '/v1.0/iwrs/unit/all?' + query,
    method: 'get'
  })
}

// 单位列表分页
export function getUnitNoPage(query) {
  return request({
    url: '/v1.0/iwrs/unit/all_no_page',
    method: 'get',
    params: query
  })
}

// 新增单位
export function addUnit(data) {
  return request({
    url: '/v1.0/iwrs/unit/add',
    method: 'post',
    data
  })
}

// 编辑单位
export function editUnit(data) {
  return request({
    url: '/v1.0/iwrs/unit/update',
    method: 'put',
    data
  })
}

// 单位详情
export function detailUnit(query) {
  return request({
    url: '/v1.0/iwrs/unit/detail',
    method: 'get',
    params: query
  })
}

// 删除单位
export function delUnit(data) {
  return request({
    url: '/v1.0/iwrs/unit/remove',
    method: 'delete',
    data
  })
}

// 启用、禁用
export function enable(data) {
  return request({
    url: '/v1.0/iwrs/unit/set/enable',
    method: 'put',
    data
  })
}

// 可以导入的所有
export function unitAll(query) {
  return request({
    url: '/v1.0/iwrs/unit/can_import_all',
    method: 'get',
    params: query
  })
}

// 导入
export function leadingIn(data) {
  return request({
    url: '/v1.0/iwrs/unit/import',
    method: 'post',
    data
  })
}

// 所有研究中心
export function researchAll(query) {
  return request({
    url: '/v1.0/iwrs/unit/all/research_center',
    method: 'get',
    params: query
  })
}
